<form
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="10px"
    [formGroup]="form"
    *letVar="{ params: queryParams$ | async, isPending: isPending$ | async } as calls"
    (ngSubmit)="login(form)"
>
    <mat-form-field>
        <input type="email" lowercase-inp matInput placeholder="Email" formControlName="email" autofocus />
        <mat-error>
            <app-validation-message [touched]="fields.email.touched" [errors]="fields.email.errors"></app-validation-message>
        </mat-error>
    </mat-form-field>

    <mat-form-field>
        <input type="password" matInput placeholder="Password" formControlName="password" />
        <mat-error>
            <app-validation-message [touched]="fields.password.touched" [errors]="fields.password.errors"></app-validation-message>
        </mat-error>
    </mat-form-field>

    <mat-error *ngIf="errorMessage$ | async as errorMessage">
        {{ errorMessage }}
    </mat-error>
    <mat-error *ngIf="expiredMessage$ | async as expiredMessage">{{ expiredMessage }}</mat-error>
    <div class="forgot-pwd-link">
        <a routerLink="/login/forgot-password" queryParamsHandling="merge" class="forgotPassword">Forgot Password?</a>
    </div>
    <button mat-raised-button color="primary" class="login" [disabled]="form.invalid || form.disabled">Sign In</button>
    <a
        *ngIf="calls.params?.staff !== 'false'"
        fxShow
        mat-stroked-button
        color="secondary"
        class="register"
        fxHide.gt-xs="true"
        routerLink="/login"
        queryParamsHandling="merge"
        (click)="cancelPending()"
    >
        Cancel
    </a>
</form>
